// 引入axios组件
import axios from 'axios';
import qs from 'qs'; // 处理数据  qs.stringify(params)
import { checkRule } from '@/assets/js/public';
// 引入公共js文件
export default {
  data() {
    return {
      title: '', // 面包屑标题
      authtitle: '',
      authname: '',
      authid: '',
      auth_pid: '',
      buttonProps: {
        type: 'ghost',
        size: 'small',
      },
      //= =========================以下是模态框相关
      modal1: false, // 模态框显示开关，true显示   false不显示
    };
  },
  created() {
    this.$Spin.show();
    setTimeout(() => {
      this.$Spin.hide();
    }, 500);
  },
  computed: {
    categorylist() {
      console.log(this.$store.state.admin.adminAuthinfo);
      return this.$store.state.admin.adminAuthinfo;
    },
    categoryonelist() {
      return this.$store.state.admin.adminAuthCate;
    },
  },
  methods: {
    // 添加规则（打开模态框）；
    addArticleCategory() {
      this.modal1 = true; // 模态框显示开关，true显示   false不显示
      this.title = '添加权限';
      this.authtitle = '';
      this.authname = '';
      this.auth_pid = '';
      this.authid = '';
    },
    // 添加弹出框点击确定之后走的方法
    ok() {
      const self = this; // 将this对象附到一个不可更改的变量中~
      axios({
        method: 'post',
        url: '/admin/admin/adminAuthUpdate',
        data: {
          authtitle: this.authtitle,
          authname: this.authname,
          authid: this.authid,
          auth_pid: this.auth_pid,
        },
      })
        .then((response) => {
          checkRule(response, self); // 检查是否有权限

          if (response.data.code == 1) {
            self.$Message.success(response.data.msg);
            self.$store.commit('adminAuthInfoAgain');
            self.authtitle = '';
            self.authname = '';
            self.auth_pid = '';
            self.authid = '';
            // self.data6.splice(param.index, 1);//如果把那个1改成0，就是不删除
          } else {
            self.$Message.error(response.data.msg);
          }
        })
        .catch((response) => {
          // self.$Message.error(response.data.msg);
        });
    },
    // 添加弹出框点击取消走的方法
    cancel() {
      this.modal1 = false;
    },
    // 点击每个一级分类前面的弹出框执行的事件
    letgo(getid) {
      this.$store.commit('changeCatePid', getid);
    },
    editCategory(cateid) {
      const self = this; // 将this对象附到一个不可更改的变量中~
      this.modal1 = true; // 模态框显示开关，true显示   false不显示
      axios({
        method: 'post',
        url: '/admin/admin/adminAuthEdit',
        data: { authid: cateid },
      })
        .then((response) => {
          checkRule(response, self); // 检查是否有权限

          self.authtitle = response.data.authinfo.title;
          self.authname = response.data.authinfo.name;
          self.auth_pid = response.data.authinfo.auth_pid;
          self.authid = response.data.authinfo.id; //* /
        })
        .catch((response) => {
          // self.$Message.error("请求失败");
        });
    },
    delCategory(authid) {
      const self = this; // 将this对象附到一个不可更改的变量中~
      axios({
        method: 'post',
        url: '/admin/admin/adminAuthDel',
        data: { authid },
      })
        .then((response) => {
          checkRule(response, self); // 检查是否有权限

          if (response.data.code == 1) {
            // self.data6.splice(param.index, 1);//如果把那个1改成0，就是不删除
            for (const i in self.categorylist) {
              const delid = self.categorylist[i].id;
              if (delid == authid) {
                self.categorylist.splice(i, 1);
              }
            }
            self.$Message.success(response.data.msg);
          } else {
            self.$Message.error(response.data.msg);
          }
        })
        .catch((response) => {
          // self.$Message.error('请求失败');
        });
    },
  },
};
